import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { HAlign, VAlign } from '@algbra/ui/enums/align'
import classNames from 'classnames'
import { mapIndexed } from 'rambdax'
import styles from './TextContentBox.module.scss'

export type ZoneTextContentBoxProps = {
  __typename: 'StrapiGQL_ComponentZonesTextContentBox'
  id: string
  title: string
  TextBox: Array<{ id: string; body: string }>
}

export default function ZoneTextContentBox({
  id,
  title,
  TextBox,
}: ZoneTextContentBoxProps) {
  return (
    <Whitespace type="md">
      <Container>
        <Row hAlign={HAlign.CENTER}>
          <Column size={12} md={10} sm={12}>
            <Heading level={2} type="lg" className={classNames(styles.title)}>
              {title}
            </Heading>

            <Row className={styles.list} vAlign={VAlign.STRETCH}>
              {mapIndexed(
                ({ body }, index) => (
                  <Column
                    size={12}
                    sm={6}
                    key={`icon-item-${index}`}
                    className={styles.itemWrapper}
                  >
                    <div className={styles.item}>
                      <div dangerouslySetInnerHTML={{ __html: body }}></div>
                    </div>
                  </Column>
                ),
                TextBox
              )}
            </Row>
          </Column>
        </Row>
      </Container>
    </Whitespace>
  )
}
